import { WithSpringConfig } from 'react-native-reanimated'

export const springButtonsFixed = {
  stiffness: 100,
  damping: 25,
  mass: 1,
  overshootClamping: true,
} satisfies WithSpringConfig
